import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import MarketingLayout from "@/pages/marketing/MarketingLayout";
import Home from "@/pages/marketing/Home";
import Features from "@/pages/marketing/Features";
import FAQ from "@/pages/marketing/FAQ";
import About from "@/pages/marketing/About";
import Terms from "@/pages/marketing/Terms";
import DataDeletion from "@/pages/marketing/DataDeletion";
import PrivacyPolicy from "@/pages/PrivacyPolicy";

export default function MarketingSite() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MarketingLayout><Home /></MarketingLayout>} />
        <Route path="/features" element={<MarketingLayout><Features /></MarketingLayout>} />
        <Route path="/faq" element={<MarketingLayout><FAQ /></MarketingLayout>} />
        <Route path="/about" element={<MarketingLayout><About /></MarketingLayout>} />
        <Route path="/terms" element={<MarketingLayout><Terms /></MarketingLayout>} />
        <Route path="/privacy" element={<MarketingLayout><PrivacyPolicy /></MarketingLayout>} />
        <Route path="/data-deletion" element={<MarketingLayout><DataDeletion /></MarketingLayout>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
